import apiCall from './apiRequest';
import endPoints from './endpoints';
import config from 'config';

const { API } = config;

export function fetchUserCommunicationPreferencesApi() {
  return apiCall({
    method: 'get',
    url: `${API.fastApi}/${endPoints.me.communicationPreferences}`
  });
}

export function updateUserCommunicationPreferencesApi(payload = {}) {
  return apiCall({
    method: 'put',
    url: `${API.fastApi}/${endPoints.me.communicationPreferences}`,
    payload
  });
}

export default {
  fetchUserCommunicationPreferencesApi,
  updateUserCommunicationPreferencesApi
};



// WEBPACK FOOTER //
// ./src/api/communicationPreferences.js